import { forwardRef } from 'react';
import Skeleton from '@mui/material/Skeleton';

import { CallHistoryRowLoadingProps } from './CallHistoryRowLoading.types';

const CallHistoryRowLoadingComponent = forwardRef<HTMLDivElement, CallHistoryRowLoadingProps>((props, ref) => {
  const { id, style, showNavigationNode, navigationNode } = props;

  return (
    <div
      id={id}
      ref={ref}
      style={style}
    >
      <div>
        <Skeleton variant="circular" width={40} height={40} />
      </div>

      <div>
        <Skeleton variant="rectangular" width={90} height={21} />
      </div>

      <div>
        <Skeleton variant="rectangular" width={90} height={21} />
      </div>

      <div>
        <Skeleton variant="rectangular" width={78} height={21} />
      </div>

      {showNavigationNode && navigationNode && (
        <div>
          <Skeleton variant="circular" width={30} height={30} />
        </div>
      )}
    </div>
  );
});

CallHistoryRowLoadingComponent.defaultProps = {
  className: undefined,
  style: undefined,
  showNavigationNode: false,
  showCallActionButton: false,
  navigationNode: undefined,
  miniVersion: false,
};

export default CallHistoryRowLoadingComponent;
